import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inner-nav',
  templateUrl: './inner-nav.component.html',
  styleUrls: ['./inner-nav.component.scss']
})
export class InnerNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
